/*
 * 模块: TermsTab
 * 职责: 渲染术语解释标签页
 * 依赖: antd组件、类型定义、FormattedText组件
 * 导出: TermsTab组件
 * 限制: 文件<280行, 函数<30行
 */

import React from 'react';
import { Collapse, Card, Space, Alert, Typography } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import type { MetricDefinition } from '../../../types';
import FormattedText from '../FormattedText';

const { Text } = Typography;

interface TermsTabProps {
  definition: MetricDefinition;
}

export const TermsTab: React.FC<TermsTabProps> = ({ definition }) => {
  if (!definition.terms || Object.keys(definition.terms).length === 0) {
    return (
      <Alert
        message="暂无术语解释"
        type="info"
        showIcon
      />
    );
  }

  return (
    <Collapse
      accordion
      expandIconPosition="end"
      items={Object.entries(definition.terms).map(([term, explanation], index) => ({
        key: String(index),
        label: (
          <Space>
            <QuestionCircleOutlined style={{ color: '#fa8c16' }} />
            <Text strong style={{ fontSize: '15px' }}>
              {term}
            </Text>
          </Space>
        ),
        children: (
          <Card size="small" style={{ background: '#fffbf0', marginTop: 8 }}>
            <div style={{ fontSize: '14px', color: '#595959', lineHeight: '1.8', textAlign: 'left' }}>
              <FormattedText text={explanation} />
            </div>
          </Card>
        ),
      }))}
    />
  );
};

